import { strapiImageGetters } from './strapiImageGetters'

const getId = (magazineHome: any): string | null => {
  return magazineHome?.id || null
}

const getSeoTitle = (magazineHome: any): string | null => {
  return magazineHome?.seo?.metaTitle || null
}

const getSeoImageUrl = (
  magazineHome: any,
  format: 'thumbnail' | 'small' | 'medium' | 'large' | null = null
): string | null => {
  return (
    strapiImageGetters.getImageUrl(
      magazineHome?.seo?.metaImage?.data,
      format
    ) || null
  )
}

const getSeoMetaDescription = (magazineHome: any): string | null => {
  return magazineHome?.seo?.metaDescription || null
}

const getSummaryList = (magazineHome: any): any => {
  return magazineHome?.summary_list || null
}

export const magazineHomeGetters = {
  getId,
  getSeoTitle,
  getSeoImageUrl,
  getSeoMetaDescription,
  getSummaryList,
}
